module.exports = __webpack_public_path__ + "static/media/exc_bat_bac.f61a02fb.png";